import { State, Selector, Action, StateContext } from '@ngxs/store';
import { tap, catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { DashboardModel, DashboardsClient } from '@core/services/api.service';
import { LoadDashboardsAction, LoadDashboardsSuccessAction, LoadDashboardsFailAction, LoadControlTowerDashboardsV1Action, LoadControlTowerDashboardsV1SuccessAction, LoadControlTowerDashboardsV1FailAction, LoadCustomsDashboardsV1Action, LoadCustomsDashboardsV1FailAction, LoadCustomsDashboardsV1SuccessAction, LoadNoVehicleDashboardsAction, LoadNoVehicleDashboardsSuccessAction, LoadNoVehicleDashboardsFailAction, LoadCollectPodJobCountAction, LoadCollectPodJobCountSuccessAction, LoadCollectPodJobCountFailAction, LoadPodOnlyJobCountAction, LoadPodOnlyJobCountSuccessAction, LoadPodOnlyJobCountFailAction, LoadBmwJobCountAction, LoadBmwJobCountSuccessAction, LoadBmwJobCountFailAction, LoadBmwCollectionTrackingWarningCountAction, LoadBmwCollectionTrackingWarningCountSuccessAction, LoadBmwCollectionTrackingWarningCountFailAction, LoadBmwNoLocationWarningCountAction, LoadBmwNoLocationWarningCountSuccessAction, LoadBmwNoLocationWarningCountFailAction } from './dashboards.actions';
import { OpenSnackbarAction } from '@ngxs-store/ui-store/ui.actions';
import { SnackbarType } from '@core/models';

export class DashboardsStateModel {
  public isLoading = false;
  public dashboards: DashboardModel[] = [];
  public controlTowerDashboards: DashboardModel[] = [];
  public customsDashboards: DashboardModel[] = [];
  public noVehicleDashboards: DashboardModel[] = [];
  public collectPodJobCountDashboards: DashboardModel[] = [];
  public podOnlyJobCountDashboards: DashboardModel[] = [];
  public bmwJobCountDashboards: DashboardModel[] = [];
  public bmwCollectionTrackingWarningCountDashboards: DashboardModel[] = [];
  public bmwNoLocationWarningCountDashboards: DashboardModel[] = [];
}

@State<DashboardsStateModel>({
  name: 'dashboards',
  defaults: {
    isLoading: false,
    dashboards: [],
    controlTowerDashboards: [],
    customsDashboards: [],
    noVehicleDashboards: [],
    collectPodJobCountDashboards: [],
    podOnlyJobCountDashboards: [],
    bmwJobCountDashboards: [],
    bmwCollectionTrackingWarningCountDashboards: [],
    bmwNoLocationWarningCountDashboards: []
  }
})
@Injectable()
export class DashboardsState {
  constructor(
    private dashboardsClient: DashboardsClient
  ) { }

  @Selector()
  static getIsLoading(state: DashboardsStateModel) {
    return state.isLoading;
  }

  @Selector()
  static getDashboards(state: DashboardsStateModel) {
    return state.dashboards;
  }

  @Selector()
  static getcontrolTowerDashboards(state: DashboardsStateModel) {
    return state.controlTowerDashboards;
  }

  @Selector()
  static getCustomsDashboards(state: DashboardsStateModel) {
    return state.customsDashboards;
  }

  @Selector()
  static getNoVehicleDashboards(state: DashboardsStateModel) {
    return state.noVehicleDashboards;
  }

  @Selector()
  static getCollectPodJobCountDashboards(state: DashboardsStateModel) {
    return state.collectPodJobCountDashboards;
  }

  @Selector()
  static getPodOnlyJobCountDashboards(state: DashboardsStateModel) {
    return state.podOnlyJobCountDashboards;
  }

  @Selector()
  static getBmwJobCountDashboards(state: DashboardsStateModel) {
    return state.bmwJobCountDashboards;
  }

  @Selector()
  static getBmwCollectionTrackingWarningCountDashboards(state: DashboardsStateModel) {
    return state.bmwCollectionTrackingWarningCountDashboards;
  }

  @Selector()
  static getBmwNoLocationWarningCountDashboards(state: DashboardsStateModel) {
    return state.bmwNoLocationWarningCountDashboards;
  }

  @Action(LoadDashboardsAction)
  loadDashboardsAction({ dispatch, patchState }: StateContext<DashboardsStateModel>, action: LoadDashboardsAction) {
    patchState({ isLoading: true });
    return this.dashboardsClient.getDashboards().pipe(
      tap((dashboards) => dispatch(new LoadDashboardsSuccessAction({ dashboards }))),
      catchError((err) => dispatch(new LoadDashboardsFailAction()))
    );
  }

  @Action(LoadDashboardsSuccessAction)
  loadDashboardsSuccessAction(ctx: StateContext<DashboardsStateModel>, action: LoadDashboardsSuccessAction) {
    ctx.patchState({
      isLoading: false,
      dashboards: action.payload.dashboards
    });

  }

  @Action(LoadDashboardsFailAction)
  loadDashboardsFailAction(ctx: StateContext<DashboardsStateModel>, action: LoadDashboardsFailAction) {
    ctx.patchState({
      isLoading: false
    });
  }

  //-------

  @Action(LoadControlTowerDashboardsV1Action)
  loadControlTowerDashboardsV1Action({ dispatch, patchState }: StateContext<DashboardsStateModel>, action: LoadControlTowerDashboardsV1Action) {
    patchState({ isLoading: true });
    return this.dashboardsClient.getControlTowerDashboard().pipe(
      tap((dashboards) => dispatch(new LoadControlTowerDashboardsV1SuccessAction({ dashboards }))),
      catchError((err) => dispatch(new LoadControlTowerDashboardsV1FailAction()))
    );
  }

  @Action(LoadControlTowerDashboardsV1SuccessAction)
  loadControlTowerDashboardsV1SuccessAction(ctx: StateContext<DashboardsStateModel>, action: LoadControlTowerDashboardsV1SuccessAction) {
    ctx.patchState({
      isLoading: false,
      controlTowerDashboards: action.payload.dashboards
    });

  }

  @Action(LoadControlTowerDashboardsV1FailAction)
  loadControlTowerDashboardsV1FailAction(ctx: StateContext<DashboardsStateModel>, action: LoadControlTowerDashboardsV1FailAction) {
    ctx.patchState({
      isLoading: false
    });
  }

  //------

  @Action(LoadCustomsDashboardsV1Action)
  loadCustomsDashboardsV1Action({ dispatch, patchState }: StateContext<DashboardsStateModel>, action: LoadCustomsDashboardsV1Action) {
    patchState({ isLoading: true });
    return this.dashboardsClient.getCustomsDashboard().pipe(
      tap((dashboards) => dispatch(new LoadCustomsDashboardsV1SuccessAction({ dashboards }))),
      catchError((err) => dispatch(new LoadCustomsDashboardsV1FailAction()))
    );
  }

  @Action(LoadCustomsDashboardsV1SuccessAction)
  loadCustomsDashboardsV1SuccessAction(ctx: StateContext<DashboardsStateModel>, action: LoadCustomsDashboardsV1SuccessAction) {
    ctx.patchState({
      isLoading: false,
      customsDashboards: action.payload.dashboards
    });

  }

  @Action(LoadCustomsDashboardsV1FailAction)
  loadCustomsDashboardsV1FailAction(ctx: StateContext<DashboardsStateModel>, action: LoadCustomsDashboardsV1FailAction) {
    ctx.patchState({
      isLoading: false
    });
  }

  //------

  @Action(LoadNoVehicleDashboardsAction)
  loadNoVehicleDashboardsAction({ dispatch, patchState }: StateContext<DashboardsStateModel>, action: LoadNoVehicleDashboardsAction) {
    patchState({ isLoading: true });
    return this.dashboardsClient.getNoVehicleDash().pipe(
      tap((dashboards) => dispatch(new LoadNoVehicleDashboardsSuccessAction({ dashboards }))),
      catchError((err) => dispatch(new LoadNoVehicleDashboardsFailAction()))
    );
  }

  @Action(LoadNoVehicleDashboardsSuccessAction)
  loadNoVehicleDashboardsSuccessAction(ctx: StateContext<DashboardsStateModel>, action: LoadNoVehicleDashboardsSuccessAction) {
    ctx.patchState({
      isLoading: false,
      noVehicleDashboards: action.payload.dashboards
    });
  }

  @Action(LoadNoVehicleDashboardsFailAction)
  loadNoVehicleDashboardsFailAction(ctx: StateContext<DashboardsStateModel>, action: LoadNoVehicleDashboardsFailAction) {
    ctx.patchState({
      isLoading: false
    });
  }

  //------

  @Action(LoadCollectPodJobCountAction)
  loadCollectPodJobCountAction({ dispatch, patchState }: StateContext<DashboardsStateModel>, action: LoadCollectPodJobCountAction) {
    patchState({ isLoading: true });
    return this.dashboardsClient.getCollectPodJobCount().pipe(
      tap((dashboards) => dispatch(new LoadCollectPodJobCountSuccessAction({ dashboards }))),
      catchError((err) => dispatch(new LoadCollectPodJobCountFailAction()))
    );
  }

  @Action(LoadCollectPodJobCountSuccessAction)
  loadCollectPodJobCountSuccessAction(ctx: StateContext<DashboardsStateModel>, action: LoadCollectPodJobCountSuccessAction) {
    ctx.patchState({
      isLoading: false,
      collectPodJobCountDashboards: action.payload.dashboards
    });
  }

  @Action(LoadCollectPodJobCountFailAction)
  loadCollectPodJobCountFailAction(ctx: StateContext<DashboardsStateModel>, action: LoadCollectPodJobCountFailAction) {
    ctx.patchState({
      isLoading: false
    });
  }

  //------

  @Action(LoadPodOnlyJobCountAction)
  loadPodOnlyJobCountAction({ dispatch, patchState }: StateContext<DashboardsStateModel>, action: LoadPodOnlyJobCountAction) {
    patchState({ isLoading: true });
    return this.dashboardsClient.getPodOnlyJobCount().pipe(
      tap((dashboards) => dispatch(new LoadPodOnlyJobCountSuccessAction({ dashboards }))),
      catchError((err) => dispatch(new LoadPodOnlyJobCountFailAction()))
    );
  }

  @Action(LoadPodOnlyJobCountSuccessAction)
  loadPodOnlyJobCountSuccessAction(ctx: StateContext<DashboardsStateModel>, action: LoadPodOnlyJobCountSuccessAction) {
    ctx.patchState({
      isLoading: false,
      podOnlyJobCountDashboards: action.payload.dashboards
    });
  }

  @Action(LoadPodOnlyJobCountFailAction)
  loadPodOnlyJobCountFailAction(ctx: StateContext<DashboardsStateModel>, action: LoadPodOnlyJobCountFailAction) {
    ctx.patchState({
      isLoading: false
    });
  }

  //------

  @Action(LoadBmwJobCountAction)
  loadBmwJobCountAction({ dispatch, patchState }: StateContext<DashboardsStateModel>, action: LoadBmwJobCountAction) {
    patchState({ isLoading: true });
    return this.dashboardsClient.getBmwJobCount().pipe(
      tap((dashboards) => dispatch(new LoadBmwJobCountSuccessAction({ dashboards }))),
      catchError((err) => dispatch(new LoadBmwJobCountFailAction()))
    );
  }

  @Action(LoadBmwJobCountSuccessAction)
  loadBmwJobCountSuccessAction(ctx: StateContext<DashboardsStateModel>, action: LoadBmwJobCountSuccessAction) {
    ctx.patchState({
      isLoading: false,
      bmwJobCountDashboards: action.payload.dashboards
    });
  }

  @Action(LoadBmwJobCountFailAction)
  loadBmwJobCountFailAction(ctx: StateContext<DashboardsStateModel>, action: LoadBmwJobCountFailAction) {
    ctx.patchState({
      isLoading: false
    });
  }

  //------

  @Action(LoadBmwCollectionTrackingWarningCountAction)
  loadBmwCollectionTrackingWarningCountAction({ dispatch, patchState }: StateContext<DashboardsStateModel>, action: LoadBmwCollectionTrackingWarningCountAction) {
    patchState({ isLoading: true });
    return this.dashboardsClient.getBmwCollectionTrackingWarningCount().pipe(
      tap((dashboards) => dispatch(new LoadBmwCollectionTrackingWarningCountSuccessAction({ dashboards }))),
      catchError((err) => dispatch(new LoadBmwCollectionTrackingWarningCountFailAction()))
    );
  }

  @Action(LoadBmwCollectionTrackingWarningCountSuccessAction)
  loadBmwCollectionTrackingWarningCountSuccessAction(ctx: StateContext<DashboardsStateModel>, action: LoadBmwCollectionTrackingWarningCountSuccessAction) {
    ctx.patchState({
      isLoading: false,
      bmwCollectionTrackingWarningCountDashboards: action.payload.dashboards
    });
  }

  @Action(LoadBmwCollectionTrackingWarningCountFailAction)
  loadBmwCollectionTrackingWarningCountFailAction(ctx: StateContext<DashboardsStateModel>, action: LoadBmwCollectionTrackingWarningCountFailAction) {
    ctx.patchState({
      isLoading: false
    });
  }

  //------

  @Action(LoadBmwNoLocationWarningCountAction)
  loadBmwNoLocationWarningCountAction({ dispatch, patchState }: StateContext<DashboardsStateModel>, action: LoadBmwNoLocationWarningCountAction) {
    patchState({ isLoading: true });
    return this.dashboardsClient.getBmwNoLocationWarningCount().pipe(
      tap((dashboards) => dispatch(new LoadBmwNoLocationWarningCountSuccessAction({ dashboards }))),
      catchError((err) => dispatch(new LoadBmwNoLocationWarningCountFailAction()))
    );
  }

  @Action(LoadBmwNoLocationWarningCountSuccessAction)
  loadBmwNoLocationWarningCountSuccessAction(ctx: StateContext<DashboardsStateModel>, action: LoadBmwNoLocationWarningCountSuccessAction) {
    ctx.patchState({
      isLoading: false,
      bmwNoLocationWarningCountDashboards: action.payload.dashboards
    });
  }

  @Action(LoadBmwNoLocationWarningCountFailAction)
  loadBmwNoLocationWarningCountFailAction(ctx: StateContext<DashboardsStateModel>, action: LoadBmwNoLocationWarningCountFailAction) {
    ctx.patchState({
      isLoading: false
    });
  }
}
